<template>
  <li class="the-search-suggestion">
    <a
      ref="anchor"
      class="the-search-suggestion__link"
      :href="href"
      @click.prevent="click"
      @focus="$emit('focus')"
      @focusout="$emit('focusout')"
    >
      <span
        v-for="(token, index) in tokens"
        :key="index"
        :class="[
          token.toLowerCase() === match.toLowerCase()
            ? 'the-search-suggestion__match'
            : 'the-search-suggestion__prediction'
        ]"
      >{{ token }}</span>
    </a>
  </li>
</template>

<script>
export default {
  name: 'TheSearchSuggestion',

  props: {
    match: {
      type: String,
      required: true,
    },
    searchBaseUrl: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
  },

  computed: {
    href() {
      return `${this.searchBaseUrl}?q=${encodeURIComponent(this.text)}`;
    },
    tokens() {
      const regex = RegExp(`(.*)(${this.match})(.*)`, 'gi');
      const result = regex.exec(this.text);
      if (result !== null && result.length > 0) {
        return result
          .slice(1)
          .filter((item) => item !== undefined && item !== '');
      }
      return [this.text];
    },
  },

  methods: {
    click() {
      this.$emit('click', this);
    },

    focus() {
      this.$refs.anchor.focus();
    },
  },
};
</script>
